import { Checkbox, List, ListItem, Divider, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { listSelectorStyles } from './styles';

function SelectionList({
    options,
    control,
    disabled,
    name,
    label,
    rules,
    defaultValue,
    isPaginated = false,
    action,
    indeterminateValues = [],
    onToggle
}) {
    const classes = makeStyles(listSelectorStyles)();
    const [clearedIndeterminate, setClearedIndeterminate] = useState([]);

    return (
        <div>
            <b>{label}</b>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ onChange, value }) => {
                    const handleToggle = option => {
                        const isIndeterminate =
                            indeterminateValues.includes(option.value) && !clearedIndeterminate.includes(option.value);

                        if (isIndeterminate) {
                            setClearedIndeterminate([...clearedIndeterminate, option.value]);
                            const newChecked = [...(value || []), option.value];
                            onChange(newChecked);
                            if (onToggle) onToggle(option.value);
                            return;
                        }

                        const currentIndex = (value || []).findIndex(v => v === option.value);
                        const newChecked = [...(value || [])];

                        if (currentIndex === -1) {
                            newChecked.push(option.value);
                        } else {
                            newChecked.splice(currentIndex, 1);
                        }
                        onChange(newChecked);
                        if (onToggle) onToggle(option.value);
                    };
                    return (
                        <List
                            className={classes.listContainer}
                            onScroll={e => {
                                const element = e.target;
                                const scrollPosition = element.scrollTop;
                                if (
                                    isPaginated &&
                                    action &&
                                    element.scrollTop / (element.scrollHeight - element.clientHeight) >= 1
                                )
                                    action().then(() => {
                                        element.scrollTop = scrollPosition;
                                    });
                            }}
                        >
                            {!options.length && 'Loading...'}
                            {options.map((option, index) => {
                                const isIndeterminate =
                                    indeterminateValues.includes(option.value) &&
                                    !clearedIndeterminate.includes(option.value);
                                const isChecked = !isIndeterminate && value && value.some(v => v === option.value);
                                return (
                                    <>
                                        <ListItem
                                            disabled={disabled}
                                            key={index}
                                            role={undefined}
                                            dense
                                            button
                                            onClick={() => handleToggle(option)}
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={isChecked}
                                                    indeterminate={isIndeterminate}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={option.label} secondary={option.subtitle} />
                                        </ListItem>
                                        <Divider />
                                    </>
                                );
                            })}
                        </List>
                    );
                }}
            />
        </div>
    );
}

SelectionList.propTypes = {
    options: PropTypes.array,
    control: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    rules: PropTypes.array,
    defaultValue: PropTypes.array,
    isPaginated: PropTypes.bool,
    action: PropTypes.func,
    indeterminateValues: PropTypes.array,
    onToggle: PropTypes.func
};

export default SelectionList;
